import http from 'hub-http/clients/apiClient';
import dataFetchingClient from '../../utils/DataFetchingClient';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
export const GET_MONETIZATION_PRODUCTS = registerQuery({
  fieldName: 'monetizationProducts',
  args: [],
  fetcher() {
    return http.get('/monetization/v3/product');
  }
});
export const getMonetizationProducts = () => {
  return dataFetchingClient.queryUnwrapped({
    query: GET_MONETIZATION_PRODUCTS
  });
};
export const useMonetizationProducts = () => {
  const {
    data: monetizationProducts,
    loading: monetizationProductsLoading,
    error: monetizationProductsError
  } = useQuery(GET_MONETIZATION_PRODUCTS);
  return {
    monetizationProducts,
    monetizationProductsLoading,
    monetizationProductsError
  };
};